module.exports = __webpack_public_path__ + "static/audiovisual-1ea80490168d6e4c27c9d5aee91206da.jpg";